import { Accordion } from '@/components/molecules/Accordion'
import { AccordionItem } from '@/components/molecules/AccordionItem'
import { mockReview } from '@/pages/ClubPlusPages/CreateTier/CreateTierSchemas'
import { DataTable, ButtonWithIcon } from "@/components/atoms"
import { Font } from 'pepsico-ds'
import { useMemo } from 'react'
import { TabsComponent } from '@/components/molecules'
import { useIntl } from 'react-intl'
import { SIZE } from '@/utils/constants/globalStyle'
import { COLOR } from '@/utils/constants/colors'

const columns = [
  { columnKey: 'activityName', header: 'ACTIVITY' },
  { columnKey: 'multiplier', header: 'POINT MULTIPLIER', cellData: (ctx) => <span>{ctx.row.original.multiplier}x</span>, },
];

const DisplayContent = ({ content }) => {
  const { formatMessage } = useIntl()

  return (
    <>
      <div className="my-5">
        <Font variant="bold" size="body" textColorClass="text-white">
          {formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_HOMEPAGE_TITLE' })}
        </Font>
      </div>
      <div className='flex justify-between align-top'>
        <div className='flex gap-4 w-60'>
          <img src={content.imageTierIcon} alt="" style={{ width: '156px', height: '100px', border: '1px solid #818181', borderRadius: '8px' }} />
          <div>
            <div className='review_subtitle'>{formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_FORM_TIER_NAME_LABEL' })}</div>
            <div className="review_title"><span>mockImage.png</span></div>
          </div>
        </div>
        <div className='w-60'>
          <div className='review_subtitle'>{formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_REVIEW_DISPLAY_NAME' })}</div>
          <div className="review_title"><span>{content.tierName}</span></div>
        </div>
        <div className='w-60'>
          <div className='review_subtitle'>
            {formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_FORM_DESCRIPTION_LABEL' })}
          </div>
          <div className="review_title"><span>{content.displayDescription}</span></div>
        </div>
      </div>

      <div className="my-5">
        <Font variant="bold" size="body" textColorClass="text-white">
          {formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_DETAIL_BANNER' })}
        </Font>
      </div>
      <div className='flex justify-between align-top'>
        <div className='flex gap-4 w-60'>
          <img src={content.bannerImage} alt="" style={{ width: '156px', height: '100px', border: '1px solid #818181', borderRadius: '8px' }} />
          <div>
            <div className='review_subtitle'>
              {formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_REVIEW_HOMEPAGE_IMAGE' })}
            </div>
            <div className="review_title"><span>mockImage.png</span></div>
          </div>
        </div>
        <div className='w-60'>
          <div className='review_subtitle'>
            {formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_FORM_BANNER_HEADER_LABEL' })}
          </div>
          <div className="review_title"><span>{content.bannerHeader}</span></div>
        </div>
        <div className='w-60'>
          <div className='review_subtitle'>
            {formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_FORM_DESCRIPTION_LABEL' })}
          </div>
          <div className="review_title"><span>{content.bannerDescription}</span></div>
        </div>
      </div>

      <div className="my-5">
        <Font variant="bold" size="body" textColorClass="text-white">
          {formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_DETAIL_PAGE' })}
        </Font>
      </div>
      <div className='flex justify-between align-top gap-'>
        <div className='flex gap-4 w-60'>
          <img src={content.detailsImage} alt="" style={{ width: '156px', height: '100px', border: '1px solid #818181', borderRadius: '8px' }} />
          <div>
            <div className='review_subtitle'>
              {formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_FORM_DETAIL_PAGE_IMG' })}
            </div>
            <div className="review_title"><span>mockImage.png</span></div>
          </div>
        </div>
        <div className='w-60'>
          <div className='review_subtitle'>
            {formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_FORM_DESCRIPTION_LABEL' })}
          </div>
          <div className="review_title"><span>{content.detailsDescription}</span></div>
        </div>
        <div className='w-60'>
          <div className='review_subtitle'>
            {formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_FORM_TERMS_CONDITIONS_LABEL' })}
          </div>
          <div className="review_title"><span>{content.detailsTermsAndConditions}</span></div>
        </div>
      </div>
    </>
  )
};

export const Review = ({ setPhase }) => {
  const { formatMessage } = useIntl()

  const tabLangs = useMemo(() => [
    { id: formatMessage({ id: 'LANGUAGES.ENGLISH_ID' }), tabLabel: formatMessage({ id: 'LANGUAGES.ENGLISH_LABEL' }), title: formatMessage({ id: 'LANGUAGES.ENGLISH_LABEL' }), tabComponent: <DisplayContent content={formatMessage({ id: 'LANGUAGES.ENGLISH_ID' })} /> },
    { id: formatMessage({ id: 'LANGUAGES.SPANISH_MEXICO_ID' }), tabLabel: formatMessage({ id: 'LANGUAGES.SPANISH_MEXICO_LABEL' }), title: formatMessage({ id: 'LANGUAGES.SPANISH_MEXICO_LABEL' }), tabComponent: <DisplayContent content={formatMessage({ id: 'LANGUAGES.SPANISH_MEXICO_ID' })} /> },
  ], [formatMessage]);

  return (
    <div className="create-tier-review mt-16 flex flex-col gap-6">
      <Accordion
        isDark
        size="large"
        presentation="border"
        separator
        content={
          <>
            <AccordionItem
              isDark
              expanded
              label="Tier Setup"
              size='small'
              rightAccessoryChild={(
                <ButtonWithIcon
                  uiSchema={{
                    className: 'ml-8 flex items-center text-sm text-[#0069D7] border-none',
                    title: 'Edit',
                    size: SIZE.SMALL,
                    variant: COLOR.TERTIARY,
                    isDark: true,
                  }}
                  iconLeading="edit"
                  handleButton={() => {
                    setPhase(1);
                  }}
                />
              )}
              content={(
                <div className='w-full mt-5'>
                  <div className="mt-10">
                    <Font variant="bold" size="body" textColorClass="text-white">
                      {formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_SETUP_ACTIVITIES' })}
                    </Font>
                  </div>
                  <div className="tier-review-table">
                    <DataTable
                      columns={columns}
                      data={mockReview.activities}
                      isDark
                      selection='single'
                      showFilterButton={false}
                      showColumnFilters={false}
                      manualPagination={false}
                      enableSorting={false}
                      showGlobalActions={false}
                    />
                  </div>
                </div>
              )}
            />
          </>
        }
      />
      <Accordion
        isDark
        size="large"
        presentation="border"
        separator
        content={
          <>
            <AccordionItem
              isDark
              expanded
              label="Display"
              size='small'
              rightAccessoryChild={(
                <ButtonWithIcon
                  uiSchema={{
                    className: 'ml-8 flex items-center text-sm text-[#0069D7] border-none',
                    title: 'Edit',
                    size: SIZE.SMALL,
                    variant: COLOR.TERTIARY,
                    isDark: true,
                  }}
                  iconLeading="edit"
                  handleButton={() => {
                    setPhase(2);
                  }}
                />
              )}
              content={(
                <div className='w-full mt-5'>
                  <div className='review_subtitle'>Tier</div>
                  <div className="review_title"><span>{mockReview.tierID}</span></div>
                  <div className="mt-10">
                    <Font variant="bold" size="body" textColorClass="text-white">
                      {formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_HOMEPAGE_PREVIEW' })}
                    </Font>
                  </div>
                  <TabsComponent tabList={tabLangs} />
                </div>
              )}
            />
          </>
        }
      />
    </div>
  )
}
